import { z } from 'zod';
import { Country, FromSchema } from '@40seas/entities/common';

export const PlaidPlaidInstitutionSchema = z
    .object({
        institutionId: z.string().nullish(),
        name: z.string().nullish(),
        logo: z.string().nullish(),
        country: z.string().nullish(),
    })
    .strict();

export class PlaidInstitution extends FromSchema(PlaidPlaidInstitutionSchema) {
    institutionId: string;
    name: string;
    logo?: string;
    country?: Country;
}
